export const columns = [
  {
    title: "发货编号",
    dataIndex: "deliveryTaskCode",
    key: "deliveryTaskCode",
  },
  {
    title: "退货截止时间",
    dataIndex: "returnDeadlineTime",
    key: "returnDeadlineTime",
    scopedSlots: {
      customRender: "returnDeadlineTime",
    },
  },
  {
    title: "批次包编码",
    dataIndex: "pkgCode",
    key: "pkgCode",
  },
  {
    title: "商品信息",
    key: "productImgUrl",
    width: 250,
    dataIndex: "productImgUrl",
    scopedSlots: {
      customRender: "productImgAction",
    },
  },
  {
    title: "发货数量",
    dataIndex: "deliveryNum",
    key: "deliveryNum",
    width: 100,
  },
  {
    title: "收件人",
    dataIndex: "receiver",
    key: "receiver",
  },
  {
    title: "手机号",
    dataIndex: "mobile",
    key: "mobile",
    width: 150,
  },
  {
    title: "收件地址",
    dataIndex: "address",
    key: "address",
  },
  {
    title: "采购单号",
    dataIndex: "purchaseNo",
    key: "purchaseNo",
  },
  {
    title: "异常采购单",
    dataIndex: "purchaseAbnormalNo",
    key: "purchaseAbnormalNo",
    customRender: (text, record, index) => {
      return text || '-';
    },
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    key: "createTime",
  },

  // {
  //   title: "收件地址",
  //   dataIndex: "addressDesc",
  //   key: "addressDesc",
  //   customRender: (text, record, index) => {
  //     let address =
  //       record.address + " " + record.receiver + " " + record.mobile;
  //     if (record.province && record.city && record.area) {
  //       address += record.province + record.city + record.area;
  //     }
  //     return address;
  //   },
  // },
  // {
  //   title: "物流单号",
  //   dataIndex: "logisticsNo",
  //   key: "logisticsNo",
  //   scopedSlots: {
  //     customRender: "expressNoAction",
  //   },
  // },
  // {
  //   title: "操作",
  //   key: "action",
  //   dataIndex: "action",
  //   width: 140,
  //   scopedSlots: {
  //     customRender: "action",
  //   },
  // },
];

export const action = {
  title: "操作",
  key: "action_dynamic",
  dataIndex: "action",
  fixed:'right',
  width: 140,
  scopedSlots: {
    customRender: "action",
  },
};

export const logisticsNo = {
  title: "物流单号",
  dataIndex: "logisticsNo",
  key: "logisticsNo_dynamic",
  width: 250,
  fixed:'right',
  scopedSlots: {
    customRender: "expressNoAction",
  },
};

function Cols() {}

Cols.get = function () {
  return columns;
};

export default Cols;
